import Tooltip from './Tooltip';
import Popup from './Popup';
export { Popup };
export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ./~/rc-tooltip/es/index.js
// module id = 2202
// module chunks = 0